/* istanbul ignore file: Directive */
'use strict';

/**
 * Execute an expression when en the backing model when enter is pressed on an input field
 */
customerZone.directive('onEnter', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {'onEnter': '&'},
        link: function(scope, element, attrs, ctrl) {
            element.on('keydown', function(ev) {
                if (ev.keyCode === 13) {
                    ctrl.$setTouched();
                    scope.$apply(function(){ scope.onEnter(); });
                    ev.preventDefault();
                    return false;
                }
            });
        }
    };
});
